// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.landlord.MarkOneTimePaymentAsPaidOfflineWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { MarkOneTimePaymentAsPaidOfflineWebApiHandler_markOneTimePaymentAsPaidOffline } from '@zg-rentals/ts-rent-payment-client';

import type { MarkOneTimePaymentAsPaidOfflineWebApiRequestDto } from '@zg-rentals/ts-rent-payment-client';

export interface MarkOneTimePaymentAsPaidOfflineWebApiHandler_markOneTimePaymentAsPaidOffline_Args {
  postData: MarkOneTimePaymentAsPaidOfflineWebApiRequestDto;
}

export type MarkOneTimePaymentAsPaidOfflineWebApiHandler_markOneTimePaymentAsPaidOffline_Options = UseMutationOptions<
  void,
  unknown,
  MarkOneTimePaymentAsPaidOfflineWebApiHandler_markOneTimePaymentAsPaidOffline_Args
>;

/**
 * Mark a one-time payment or move-in costs group as received offline, on behalf of the landlord
 */
export const useMarkOneTimePaymentAsPaidOfflineWebApiHandler_markOneTimePaymentAsPaidOffline = ({
  httpClient,
  ...options
}: Omit<MarkOneTimePaymentAsPaidOfflineWebApiHandler_markOneTimePaymentAsPaidOffline_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: MarkOneTimePaymentAsPaidOfflineWebApiHandler_markOneTimePaymentAsPaidOffline_Args) =>
      MarkOneTimePaymentAsPaidOfflineWebApiHandler_markOneTimePaymentAsPaidOffline(args.postData, httpClient),
  });
};
